import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import {accentColorPrim, accentColorTertiary, bpXl, white} from '../../assets/styledAssets/vars';
import defaultPic from "../../assets/images/user.svg"
import * as CSS from "csstype";

export const StyledNavLink = styled(NavLink)`
  padding: 1.4rem 0 1.4rem 3rem;
  color: #000;
  font-size:1.6rem;
  transition:.2s;
  font-weight:600;
  width:100%;
  border-right:3px solid transparent;
  transition:.2s;
  display:flex;
  align-items:center;
  text-decoration:none;
  svg{
    path{stroke: #000;}
    width:3rem;
    margin-right:1.6rem;
  }
  &:hover,
  &:focus{
    background-color:${accentColorTertiary};
    text-decoration:none;
    color:#000;
  }
  &.active{
  border-right-color:${accentColorPrim};
    color: ${accentColorPrim};
    
    svg{
      path{stroke: ${accentColorPrim};}
    }
  }
`;

export const ImgWrap = styled.div<{pic:string, size?: string}>`
  width: ${props=> props.size || '6rem'};
  height: ${props=> props.size || '6rem'};
  border-radius:50%;
  background-position:center;
  background-size:cover;
  background-image: url(${props=>props.pic || defaultPic});
  background-color: ${accentColorTertiary};
`;

interface SideBarProps {
  isSidebarShow: boolean
}

export const StyledSideBar = styled.div<Partial<CSS.Properties & SideBarProps>>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 0;
  overflow: auto;
  flex-wrap: nowrap;
  position:fixed;
  top:0;
  bottom:0;
  left:-30rem;
  width:30rem;
  z-index:6;
  flex-wrap:nowrap;
  overflow-y:auto;
  transition:.2s;
  background-color:${white};
  ${(props) => props.isSidebarShow && `left:0; z-index:8;`}
  @media(min-width: ${bpXl}){
    padding: 5rem 0;
    left:0;
  }
`;
